import { render } from "./CardEducation.vue?vue&type=template&id=00acaa1a"
import script from "./CardEducation.vue?vue&type=script&lang=js"
export * from "./CardEducation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__